import { useState, useEffect } from "react";
import { Text } from "@volca/ui/components/ui/text";
import { dayjs } from "@/core/utils/date";

interface RunElapsedTimeProps {
  createdAt: string;
  className?: string;
}

export const RunElapsedTime = ({
  createdAt,
  className,
}: RunElapsedTimeProps) => {
  const [elapsed, setElapsed] = useState("");

  useEffect(() => {
    const updateElapsed = () => {
      const start = dayjs(createdAt);
      const now = dayjs();
      const seconds = now.diff(start, "second");

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      if (hours > 0) {
        setElapsed(`${hours}h ${minutes}m ${secs}s`);
      } else if (minutes > 0) {
        setElapsed(`${minutes}m ${secs}s`);
      } else {
        setElapsed(`${secs}s`);
      }
    };

    // Update immediately
    updateElapsed();

    // Update every second
    const interval = setInterval(updateElapsed, 1000);

    return () => clearInterval(interval);
  }, [createdAt]);

  return (
    <Text variant="caption" tone="muted" className={className}>
      Running for {elapsed}
    </Text>
  );
};
